import { render, staticRenderFns } from "./priSettingsDueDiligenceCategories.vue?vue&type=template&id=48a846e0"
import script from "./priSettingsDueDiligenceCategories.vue?vue&type=script&lang=js"
export * from "./priSettingsDueDiligenceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports